"use client";

import Link from "next/link";
import { usePathname } from 'next/navigation'
import { BookletCategory } from "@/@types";
import { ROUTES } from "@/config/routes";
import { cn } from "@/lib/utils";

type Props = {
    categories: BookletCategory[];
};

export default function BookletsCategoryCard({ categories }: Props) {
    const pathname = usePathname();
    return (
        <div className="flex-shrink-0 bg-white p-4">
            <h2 className="font-bold text-gray-800 mb-4">CATEGORÍAS</h2>

            <div className="flex flex-wrap gap-3">
                <Link
                    href={ROUTES.literature.root}
                    className="text-sm font-medium px-4 py-2 bg-gray-100 text-gray-700 hover:bg-gray02"
                >
                    TODAS
                </Link>

                {categories.map((category) => (
                    <Link
                        key={category.slug}
                        href={ROUTES.literature.categories(category.slug)}
                        className={cn(
                            "text-sm font-medium px-4 py-2 bg-gray-100 text-gray-700 hover:bg-gray02",
                            pathname.includes(category.slug) && "bg-gray02 text-dark01"
                        )}
                    >
                        {category.name.toUpperCase()}
                    </Link>
                ))}
            </div>
        </div>
    );
}
